import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Show-off outlined icon
 *
 * @file ShowOffOutlined.jsx
 * @author Sam George
 */
const ShowOffOutlined = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentcolor"
        d="M3.70710678,2.29289322 L21.7383297,20.3241161 C22.128854,20.7146404 22.128854,21.3478054
        21.7383297,21.7383297 C21.3478054,22.128854 20.7146404,22.128854 20.3241161,21.7383297
        L17.3921578,18.8063714 C15.7516967,19.5694467 13.9251429,19.9951038 12,19.9951038 C6.63880713,19.9951038
        2.04219905,16.694018 0.100000381,11.9975519 C1.07627271,9.63680994 2.72323617,7.62863952
        4.80086741,6.21508097 L2.29289322,3.70710678 C1.90236893,3.31658249 1.90236893,2.68341751
        2.29289322,2.29289322 C2.68341751,1.90236893 3.31658249,1.90236893 3.70710678,2.29289322
        Z M6.2454306,7.65964416 C4.58500506,8.70372256 3.21038639,10.1942444 2.2987767,11.9975519
        C4.13574904,15.6313724 7.85280338,17.9951038 12,17.9951038 C13.3510643,17.9951038 14.6564772,17.7442383
        15.8661066,17.2803202 L14.7573899,16.1716035 C13.9669569,16.6951232 13.0190823,17
        12,17 C9.23857625,17 7,14.7614237 7,12 C7,10.9809177 7.30487676,10.0330431
        7.82839654,9.2426101 L6.2454306,7.65964416 Z M12,4 C17.3611929,4 21.9578009,7.30108581
        23.8999996,11.9975519 C23.1818921,13.7340207 22.1009076,15.2797308 20.7525693,16.5383565
        L19.3384867,15.1242739 C20.2941719,14.2443439 21.0987971,13.1892457 21.7012233,11.9975519
        C19.864251,8.36373136 16.1471966,6 12,6 C11.4381218,6 10.8841392,6.04338837 10.3416581,6.12744529
        L8.65598048,4.44176768 C9.72242002,4.15363382 10.843418,4 12,4 Z M9.29237099,10.7065845
        C9.10495216,11.0982198 9,11.5368535 9,12 C9,13.6568542 10.3431458,15 12,15 C12.4631465,15
        12.9017802,14.8950478 13.2934155,14.707629 L9.29237099,10.7065845 Z M12,7 C14.7614237,7 17,9.23857625
        17,12 C17,12.2488343 16.9818228,12.4934232 16.9467239,12.7325111 L11.2674889,7.05327613
        C11.5065768,7.01817717 11.7511657,7 12,7 Z"
      />
    </g>
  </SvgIcon>
);

export default ShowOffOutlined;
